module.exports = __webpack_public_path__ + "static/media/team5.63bc6a9d.jpg";